
import { mapActions } from 'vuex';
import { initMeta } from '@/store/search';
import HorizontalSearchSkeleton from '../skeleton/HorizontalSearchSkeleton.vue';
import InfiniteSearchListItem from './InfiniteSearchListItem.vue';
export default {
  name: 'NoFilterSearchList',
  components: { InfiniteSearchListItem, HorizontalSearchSkeleton },
  data() {
    return {
      noFilterSearchList: [],
      skeletonListLength: 5,
      isLoading: false,
      meta: { ...initMeta },
    };
  },
  async created() {
    await this.addFetch();
  },
  methods: {
    ...mapActions('search', ['fetchNofilterSearchList']),
    async addFetch() {
      if (this.isLoading) return;
      this.isLoading = true;
      try {
        const { items, meta } = await this.fetchNofilterSearchList(this.meta);
        this.noFilterSearchList = [...this.noFilterSearchList, ...items];
        this.meta = meta;
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
